module.exports = __webpack_public_path__ + "static/chat-9e94a2dbd9e63db85cde454a9bee2859.svg";